export const AssetClasses = () => {
  return [
    { title: "Forex", value: "FOREX" },
    // { title: "Indices", value: "INDICES" },
    { title: "Commodities", value: "COMMODITIES" },
  ];
};
